export class EditDriversModalActionsVm {
    constructor() { }
    title?: string;
    confirmText?: string;
    cancelText?: string
    customAction?: () => any | undefined;
    customCloseAction!: () => any | undefined;
    inputs: any | undefined;
    successModal?: boolean;
}
